<div class="login-main-info">
	<div class="login-main-info__advice-block">
		@if (adviceBanners && adviceBanners.length) {
			<article class="login-main-info__slider-block">
				<div class="login-main-info__slider-block-content">
					<app-tiny-slider
						[sliderConfig]="{
							mode: 'gallery',
							autoplay: false,
							autoHeight: false,
							autoWidth: false,
							nav: false,
						}"
					>
						@for (adviceBanner of adviceBanners; track adviceBanner; let i = $index) {
							<div class="login-main-info__slider-item">
								<div
									class="login-main-info__slider-image-wrapper"
									[innerHTML]="adviceBanner?.image | trustedContent: 'svg'"
								></div>
								<section class="login-main-info__slider-text-block">
									<h3 class="login-main-info__slider-title">
										{{ adviceBanner?.text?.title }}
									</h3>
									<div
										class="login-main-info__slider-description"
										[innerHtml]="adviceBanner?.text?.desc"
									></div>
									<button
										class="button-text login-main-info__slider-next-button"
										type="button"
										(click)="slideToNextAdvice(i)"
									>
										Посмотреть еще совет
									</button>
								</section>
							</div>
						}
					</app-tiny-slider>
				</div>
			</article>
		}
	</div>
	<!-- <div class="login-main-info__qr-code-block">
  <section class="qr-code">
    <h3 class="qr-code__title">
      Русский Стандарт Онлайн
    </h3>
    <p class="qr-code__text">
      Мобильный банк
    </p>
    <img alt=""
      class="qr-code__image"
      alt="QR Code для скачивания мобильного приложения"
      title="Наведите камеру телефона, чтобы открыть или скачать Русский Стандарт Онлайн"
      width="72px"
      height="72px"
      src="./assets/images/footer/qr-code-app.jpg"
      >
    </section>
  </div> -->
	<div class="login-main-info__news-block">
		<section class="login-main-info__news">
			@if (topTwoNews?.length) {
				<h3 class="login-main-info__news-block-title">Что нового</h3>
			}
			<ul class="login-main-info__news-list">
				@for (item of topTwoNews; track item) {
					<li class="login-main-info__news-item">
						<span class="login-main-info__news-date">
							{{ item.ACTIVE_FROM | date: 'dd.MM.yyyy' }}
						</span>
						<button
							class="button-text button-text--blacked login-main-info__news-title-button"
							type="button"
							[innerHTML]="item.NAME"
							(click)="openPopup(item)"
						></button>
					</li>
				}
				<app-pop-up [id]="popupId">
					<article class="login-main-info__news-popup">
						<button
							class="close login-main-info__news-close-button"
							(click)="closePopup()"
							type="button"
						>
							Закрыть
						</button>
						<div class="popup-news">
							@if (popupNewsItem) {
								<div class="popup-news__header">
									<button
										class="button-text button-text--blacked popup-news__back-to-all-button"
										type="button"
										(click)="showAllNews()"
									>
										<app-svg-back-arrow-small
											class="popup-news__button-icon"
											width="18px"
											height="18px"
											fillColor="#84b245"
										></app-svg-back-arrow-small>
										Вернуться к списку новостей
									</button>
								</div>
								<section class="popup-news__content">
									<span class="popup-news__item-date">
										{{ popupNewsItem.ACTIVE_FROM | date: 'dd.MM.yyyy' }}
									</span>
									<h3
										class="popup-news__item-title"
										[innerHTML]="popupNewsItem.NAME"
									></h3>
									<div
										class="third-party-styles popup-news__item-content"
										[innerHTML]="popupNewsItem.DETAIL_TEXT"
									></div>
								</section>
							} @else {
								<h3 class="popup-news__block-title">Что нового</h3>
								<div class="popup-news__content">
									<ul class="popup-news__list">
										@for (item of news; track item) {
											<li class="popup-news__list-item">
												<button
													class="button-reset popup-news__list-item-icon"
													type="button"
													(click)="chooseNewsItem(item)"
												>
													<app-svg-news-paper
														height="80px"
														width="80px"
														fillColor="#83b143"
													></app-svg-news-paper>
												</button>
												<section class="popup-news__list-item-content">
													<span class="popup-news__list-item-date">
														{{ item.ACTIVE_FROM | date: 'dd.MM.yyyy' }}
													</span>
													<button
														class="button-text button-text--blacked popup-news__list-item-title-button"
														[innerHTML]="item.NAME"
														(click)="chooseNewsItem(item)"
														type="button"
													></button>
												</section>
											</li>
										}
									</ul>
								</div>
							}
						</div>
					</article>
				</app-pop-up>
			</ul>
		</section>
	</div>
</div>
